const usdCurrency = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
});

const usdCompact = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 2,
});

const percent = new Intl.NumberFormat('en-GB', {
  style: 'percent',
  signDisplay: 'exceptZero',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

export function formatPrice(value: number | null): string {
  if (value === null) return '—';
  return usdCurrency.format(value);
}

export function formatMarketCap(value: number | null): string {
  if (value === null) return '—';
  return usdCompact.format(value);
}

export function formatChangePct(value: number | null): string {
  if (value === null) return '—';
  // Finnhub returns percentages already (e.g. 1.23 = +1.23%), so divide.
  return percent.format(value / 100);
}
